import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_TICKET_REFRESH: createSagaAction('JOB_TICKET_REFRESH'),

  JOB_TICKET_CREATE: createSagaAction('JOB_TICKET_CREATE'),
  JOB_TICKET_UPDATE: createSagaAction('JOB_TICKET_UPDATE'),
  JOB_TICKET_DELETE: createSagaAction('JOB_TICKET_DELETE'),

  UPLOAD_TICKET_ATTACHMENT: createSagaAction('UPLOAD_TICKET_ATTACHMENT'),
  GET_TICKET_ATTACHMENTS: createSagaAction('GET_TICKET_ATTACHMENTS'),
  UPDATE_TICKET_ATTACHMENT_DESCRIPTION: createSagaAction('UPDATE_TICKET_ATTACHMENT_DESCRIPTION'),
  DELETE_TICKET_ATTACHMENT: createSagaAction('DELETE_TICKET_ATTACHMENT')
}

// Action Creators
export const actions = {
  jobTicketsRefresh: ({ jobId }) => ({
    type: constants.JOB_TICKET_REFRESH.ACTION,
    jobId
  }),

  createJobTicket: ({ content, jobId }) => ({
    type: constants.JOB_TICKET_CREATE.ACTION,
    content,
    jobId
  }),

  updateJobTicket: ({ content, jobId, ticketId }) => ({
    type: constants.JOB_TICKET_UPDATE.ACTION,
    content,
    jobId,
    ticketId
  }),

  deleteJobTicket: ({ ticketId, jobId }) => ({
    type: constants.JOB_TICKET_DELETE.ACTION,
    jobId,
    ticketId
  }),

  // Attachment actions
  uploadTicketAttachment: ({ formData, ticketId }) => ({
    type: constants.UPLOAD_TICKET_ATTACHMENT.ACTION,
    formData,
    ticketId
  }),

  getTicketAttachments: ({ ticketId }) => ({
    type: constants.GET_TICKET_ATTACHMENTS.ACTION,
    ticketId
  }),

  updateTicketAttachmentDescription: ({ attachmentId, ticketId, description, userId }) => ({
    type: constants.UPDATE_TICKET_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    ticketId,
    description,
    userId
  }),

  deleteTicketAttachment: ({ attachmentId, ticketId }) => ({
    type: constants.DELETE_TICKET_ATTACHMENT.ACTION,
    attachmentId,
    ticketId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_TICKET_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_TICKET_REFRESH.SUCCESS:
      return {
        ...state,
        jobTickets: action.payload
      }
    case constants.JOB_TICKET_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_TICKET_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_TICKET_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.JOB_TICKET_DELETE.SUCCESS:
      return {
        ...state
      }

    case constants.UPLOAD_TICKET_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_TICKET_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }

    case constants.GET_TICKET_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_TICKET_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        jobTicketsAttachments: action.payload,
        loadingAttachments: false
      }

    case constants.UPDATE_TICKET_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }

    case constants.DELETE_TICKET_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_TICKET_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteTicketActions.js